const initialState = {
isLoading: false,
customer:[]
}
export default initialState;